import { call, put, takeEvery, fork } from "redux-saga/effects";
import TokenService from "../services/token";
import * as actions from "../actions/auth";
import auth from "../services/auth";

function* login({ loginData }) {
  yield put(actions.startLoading());
  try {
    const res = yield call(auth.login, loginData);
    if (res) {
      TokenService.setToken(res.tokens.idToken);
      yield put(actions.loginSucceeded());
    }
  } catch (error) {
    yield put(actions.loginError(error));
    console.log(error);
  }
}

function* loginAdmin({ loginData }) {
  yield put(actions.startLoading());
  try {
    const res = yield call(auth.loginAdmin, loginData);
    if (res) {
      TokenService.setToken(res.tokens.idToken);
      yield put(actions.loginSucceeded());
    }
  } catch (error) {
    yield put(actions.loginError(error));
    console.log(error);
  }
}

function* ResetPassword({ data }) {
  yield put(actions.startLoading());
  try {
    const res = yield call(auth.resetPassword, data);
    yield put(actions.receiveResetPasswordSucceeded(res.message));
  } catch (error) {
    yield put(actions.receiveResetPasswordError(error.response.data.message));
  }
}

function* ChangePasswordEmail({ data }) {
  yield put(actions.startLoading());
  try {
    const res = yield call(auth.changePasswordEmail, data);
    if (res) {
      TokenService.clear();
      yield put(actions.changePasswordEmailSucceeded());
    }
  } catch (error) {
    yield put(actions.changePasswordEmailError(error));
    console.log(error);
  }
}

function* ChangePassword({ data }) {
  yield put(actions.startLoading());
  try {
    const res = yield call(auth.changePasswordEmail, data);
    if (res) {
      TokenService.clear();
      yield put(actions.changePasswordSucceeded(true));
    }
  } catch (error) {
    yield put(actions.changePasswordError(error));
  }
}

function* watchLoginRequest() {
  yield takeEvery(actions.Types.AUTH_OATH_REQUEST, login);
}

function* watchLoginAdminRequest() {
  yield takeEvery(actions.Types.AUTH_LOGIN_ADMIN_REQUEST, loginAdmin);
}

function* watchResetPasswordRequest() {
  yield takeEvery(actions.Types.AUTH_RESET_PASSWORD_REQUESTED, ResetPassword);
}

function* watchChangePasswordRequest() {
  yield takeEvery(actions.Types.AUTH_CHANGEPASSWORD_REQUEST, ChangePassword);
}

function* watchChangePasswordEmailRequest() {
  yield takeEvery(
    actions.Types.AUTH_RESET_PASSWORDEMAIL_REQUESTED,
    ChangePasswordEmail,
  );
}

const authSagas = [
  fork(watchLoginRequest),
  fork(watchLoginAdminRequest),
  fork(watchChangePasswordRequest),
  fork(watchResetPasswordRequest),
  fork(watchChangePasswordEmailRequest),
];

export default authSagas;
